/* Muse&Paw: product page preview of the order level quantity discounts.
   Loaded by snippets/mp-qty-discount.liquid, which supplies
   window.__MP_QTY_CONFIG with the variant prices and the money format.
   Kept out of the .liquid file on purpose: Liquid never parses a .js
   asset, so a literal double brace in here is harmless. */
(function () {
  if (window.__mpQtyDiscount) return;
  window.__mpQtyDiscount = true;

  /* Keep in step with the automatic discounts in Shopify. Highest rate
     first, which mirrors Shopify handing over whichever offer is best. */
  var QTY_TIERS = [
    { pieces: 4, rate: 0.20 },
    { pieces: 3, rate: 0.12 }
  ];

  /* 20 Sep 2026: the subtotal tier, 20% off over 190 euro from two pieces,
     has been removed here and in Shopify. A DiscountAutomaticBasic takes
     exactly one minimum requirement, a subtotal or a quantity and never
     both, so the two piece half of that rule could not be enforced and
     checkout was taking 20% off single expensive canvases. The offer is
     now counted in pieces alone, which is the only thing Shopify can hold
     itself to. If a Function ever restores a subtotal tier, it goes back
     here as well: this file and the announcement bar are the only places
     the customer is told what the offer is. */

  var CONFIG = window.__MP_QTY_CONFIG || {};
  var PRICES = CONFIG.prices || {};
  var MONEY_FORMAT = CONFIG.moneyFormat || null;
  var EURO = '€';
  var PLACEHOLDER = /\{\s*\{\s*(\w+)\s*\}\s*\}/g;

  var QUIET = window.matchMedia('(prefers-reduced-motion: reduce)');

  function group(n, decimals, thousands, decimal) {
    var fixed = Math.abs(n).toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  /* Shopify's money filter is Liquid only, so the placeholders it supports
     are reproduced here. Anything unrecognised falls back to a plain euro
     amount rather than printing a raw template string at the customer. */
  function formatMoney(cents) {
    var value = cents / 100;
    var plain = EURO + group(value, 2, '.', ',');
    if (!MONEY_FORMAT) return plain;

    var matched = false;
    var out = MONEY_FORMAT.replace(PLACEHOLDER, function (_, name) {
      matched = true;
      switch (name) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(value, 0, ' ', ',');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        default: return group(value, 2, ',', '.');
      }
    });
    return matched ? out : plain;
  }

  /* ---- the offer, in one place ------------------------------------- */

  function bestOffer(pieces) {
    for (var i = 0; i < QTY_TIERS.length; i++) {
      if (pieces >= QTY_TIERS[i].pieces) return QTY_TIERS[i].rate;
    }
    return 0;
  }

  /* How full the tube is: how close the basket has come to the four piece
     step, which is the only route to 20% now. */
  function progressFor(pieces) {
    return Math.min(1, pieces / QTY_TIERS[0].pieces);
  }

  /* Where the 12% step sits on that scale. Three pieces always lands on
     12%, so the mark is a fixed three quarters of the way along, and it is
     only worth drawing while the basket is still short of it. */
  function twelveMark(basketPieces) {
    if (basketPieces >= 3) return null;
    return progressFor(3);
  }

  function copyFor(pieces, cents) {
    var rate = bestOffer(pieces);
    var after = cents - Math.round(cents * rate);

    if (rate >= 0.20) {
      return {
        main: '20% off applies at checkout',
        sub: formatMoney(after) + ' instead of ' + formatMoney(cents)
      };
    }
    if (rate > 0) {
      return {
        main: '12% off applies at checkout',
        sub: formatMoney(after) + ' instead of ' + formatMoney(cents) + '. One more piece takes 20% off.'
      };
    }
    /* Nothing applies yet. Say how many pieces it takes to reach the first
       step, and what waits beyond it. */
    var n = 1;
    while (n < 12 && bestOffer(pieces + n) === 0) n++;
    return {
      main: 'Add ' + n + ' more ' + (n === 1 ? 'piece' : 'pieces') + ' for 12% off',
      sub: 'Four or more, 20% off'
    };
  }

  /* ---- a spring, not an easing curve -------------------------------- */

  function Spring(value) {
    this.v = value; this.t = value; this.vel = 0; this.k = 172; this.c = 20;
  }
  Spring.prototype.to = function (t) { this.t = t; };
  Spring.prototype.jump = function (t) { this.t = t; this.v = t; this.vel = 0; };
  Spring.prototype.step = function (dt) {
    var left = dt;
    while (left > 0) {
      var h = Math.min(1 / 240, left);
      left -= h;
      this.vel += (-this.k * (this.v - this.t) - this.c * this.vel) * h;
      this.v += this.vel * h;
    }
  };
  Spring.prototype.still = function () {
    return Math.abs(this.vel) < 0.0018 && Math.abs(this.v - this.t) < 0.0009;
  };

  /* ---- cart state ---------------------------------------------------- */

  var cart = { count: 0, cents: 0 };

  /* The picker counts ON TOP of the basket only while its pieces have not
     been put there yet. The moment they land, the basket is the whole truth
     and counting the picker as well would tell a shopper who just added three
     pieces that they had six, and promise 20% where checkout gives 12%. */
  var countPicker = true;
  var lastQty = null;
  var lastVariant = null;

  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        cart.count = data.item_count || 0;
        cart.cents = data.items_subtotal_price != null ? data.items_subtotal_price : (data.total_price || 0);
        render();
      })
      .catch(function () { /* blocked or offline: line-only figures still read correctly */ });
  }

  function productForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function currentVariantPrice() {
    var form = productForm();
    var input = form && form.querySelector('input[name="id"], select[name="id"]');
    var id = input && input.value;
    if (id && PRICES[id] != null) return PRICES[id];

    var urlId = new URLSearchParams(window.location.search).get('variant');
    if (urlId && PRICES[urlId] != null) return PRICES[urlId];

    var vals = Object.keys(PRICES).map(function (k) { return PRICES[k]; });
    return vals.length ? Math.min.apply(null, vals) : 0;
  }

  function quantityInput() {
    var form = productForm();
    return (form && form.querySelector('input[name="quantity"]')) ||
           document.querySelector('.quantity-selector-wrapper input[name="quantity"]');
  }

  function currentQuantity() {
    var input = quantityInput();
    var n = input ? parseInt(input.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function currentVariantId() {
    var form = productForm();
    var input = form && form.querySelector('input[name="id"], select[name="id"]');
    return (input && input.value) || '';
  }

  /* ---- watching the basket -------------------------------------------- */

  var CART_WRITE = /\/cart\/(add|change|update|clear)/i;

  /* The cart drawer edits the basket with fetch and fires nothing this code
     can rely on across themes, so the request itself is the signal. Every
     write reloads /cart.js rather than guessing at the new totals, which is
     what lets the strip follow a removal in the drawer without a refresh. */
  function watchCartWrites() {
    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function (resource) {
        var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        var promise = originalFetch.apply(this, arguments);
        if (CART_WRITE.test(url) && promise && promise.then) {
          promise.then(cartWritten, function () { /* the theme handles its own failures */ });
        }
        return promise;
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && CART_WRITE.test(url)) {
        this.addEventListener('load', cartWritten);
      }
      return originalOpen.apply(this, arguments);
    };
  }

  /* Whatever was in the picker has either landed in the basket or been
     overtaken by an edit there. Either way it stops counting on top. */
  function cartWritten() {
    countPicker = false;
    setTimeout(loadCart, 140);
  }

  /* ---- the element ---------------------------------------------------- */

  var el = null;
  var parts = null;
  var nose = new Spring(0);
  var width = 0;
  var cap = 32;
  var raf = 0;
  var prev = 0;
  var lastRate = null;

  function build() {
    var root = document.createElement('div');
    root.className = 'mp-qty-discount';

    var tube = document.createElement('div');
    tube.className = 'mp-qd-tube';

    var marks = document.createElement('div');
    marks.className = 'mp-qd-marks';
    var ghost = document.createElement('div');
    ghost.className = 'mp-qd-ghost';
    var body = document.createElement('div');
    body.className = 'mp-qd-body';
    var nib = document.createElement('div');
    nib.className = 'mp-qd-cap';
    var wave = document.createElement('div');
    wave.className = 'mp-qd-wave';
    wave.appendChild(document.createElement('i'));

    function layer(kind) {
      var c = document.createElement('div');
      c.className = 'mp-qd-copy mp-qd-copy--' + kind;
      var m = document.createElement('div');
      m.className = 'mp-qd-line mp-qd-line--main';
      m.appendChild(document.createElement('span'));
      var s = document.createElement('div');
      s.className = 'mp-qd-line mp-qd-line--sub';
      s.appendChild(document.createElement('span'));
      var g = document.createElement('span');
      g.className = 'mp-qd-goal';
      g.textContent = '20%';
      c.appendChild(m);
      c.appendChild(s);
      c.appendChild(g);
      return c;
    }

    var ink = layer('ink');
    ink.setAttribute('role', 'status');
    ink.setAttribute('aria-live', 'polite');
    var liq = layer('liq');
    liq.setAttribute('aria-hidden', 'true');

    tube.appendChild(marks);
    tube.appendChild(ghost);
    tube.appendChild(body);
    tube.appendChild(nib);
    tube.appendChild(wave);
    tube.appendChild(ink);
    tube.appendChild(liq);
    root.appendChild(tube);

    parts = {
      tube: tube, marks: marks, ghost: ghost, body: body, cap: nib, wave: wave,
      ink: ink, liq: liq,
      inkMain: ink.querySelector('.mp-qd-line--main span'),
      inkSub: ink.querySelector('.mp-qd-line--sub span'),
      liqMain: liq.querySelector('.mp-qd-line--main span'),
      liqSub: liq.querySelector('.mp-qd-line--sub span')
    };
    return root;
  }

  function mount() {
    if (el && document.body.contains(el)) return true;
    var form = productForm();
    var anchor = (form && form.querySelector('.quantity-selector-wrapper')) ||
                 document.querySelector('.quantity-selector-wrapper');
    if (!anchor) return false;
    el = build();
    anchor.insertAdjacentElement('afterend', el);
    measure();
    if (window.ResizeObserver) {
      new ResizeObserver(function () { measure(); paint(); }).observe(parts.tube);
    } else {
      window.addEventListener('resize', function () { measure(); paint(); });
    }
    return true;
  }

  /* The cap is always half the tube's height, so its curve matches the
     tube's own rounded end exactly when the fill reaches it, whatever the
     copy does to the height. */
  function measure() {
    if (!parts) return;
    var w = parts.tube.clientWidth;
    var h = parts.tube.clientHeight;
    if (w > 0) width = w;
    if (h > 0) {
      cap = Math.round(h / 2);
      parts.cap.style.width = cap + 'px';
      parts.ghost.style.width = cap + 'px';
    }
  }

  /* ---- painting -------------------------------------------------------- */

  function paint() {
    if (!parts || !width) return;
    var head = nose.v * width;

    var stretch = 1 + Math.max(-0.28, Math.min(0.5, nose.vel * 0.3));
    if (QUIET.matches) stretch = 1;

    var capLeft = head - cap * stretch;
    parts.cap.style.transform = 'translate3d(' + capLeft.toFixed(2) + 'px,0,0) scaleX(' + stretch.toFixed(4) + ')';
    /* One pixel of overlap under the cap's straight left edge, so the two
       layers can never part and show a hairline seam. */
    parts.body.style.transform = 'translate3d(' + (capLeft + 1 - width).toFixed(2) + 'px,0,0)';

    if (QUIET.matches || nose.vel <= 0.02) {
      parts.ghost.style.opacity = '0';
    } else {
      var push = nose.vel * width * 0.075;
      parts.ghost.style.opacity = Math.min(0.26, nose.vel * 0.22).toFixed(3);
      parts.ghost.style.transform = 'translate3d(' + (capLeft + push).toFixed(2) + 'px,0,0) scaleX(' + stretch.toFixed(4) + ')';
    }

    /* The words take the liquid's colour exactly where the front crosses. */
    var cut = Math.max(0, Math.min(width, head - cap * 0.45));
    var inset = 'inset(0 ' + (width - cut).toFixed(2) + 'px 0 0)';
    parts.liq.style.clipPath = inset;
    parts.wave.style.clipPath = inset;
  }

  function frame(now) {
    if (!prev) prev = now;
    var dt = Math.min(0.05, (now - prev) / 1000);
    prev = now;
    nose.step(dt);
    paint();
    if (nose.still()) {
      nose.jump(nose.t);
      paint();
      raf = 0; prev = 0;
      return;
    }
    raf = window.requestAnimationFrame(frame);
  }

  function run() { if (!raf) { prev = 0; raf = window.requestAnimationFrame(frame); } }

  /* ---- copy swaps ------------------------------------------------------ */

  function swap(node, text, slide) {
    if (node.textContent === text) return;
    if (QUIET.matches || !node.animate) { node.textContent = text; return; }
    var from = slide
      ? [{ transform: 'translateY(60%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }]
      : [{ opacity: 0 }, { opacity: 1 }];
    node.textContent = text;
    node.animate(from, { duration: 300, easing: 'cubic-bezier(.22,1.02,.36,1)' });
  }

  function celebrate() {
    if (QUIET.matches || !parts.tube.animate) return;
    parts.wave.style.opacity = '1';
    var band = parts.wave.firstElementChild;
    var a = band.animate(
      [{ transform: 'translateX(-130%)' }, { transform: 'translateX(300%)' }],
      { duration: 760, easing: 'cubic-bezier(.3,0,.2,1)' }
    );
    var clear = function () { parts.wave.style.opacity = '0'; };
    if (a.finished) a.finished.then(clear).catch(clear); else a.onfinish = clear;
    parts.tube.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.014)' }, { transform: 'scale(1)' }],
      { duration: 540, easing: 'cubic-bezier(.34,1.5,.64,1)' }
    );
  }

  function drawMarks() {
    parts.marks.textContent = '';
    var p = twelveMark(cart.count);
    if (p == null || p >= 0.99) return;
    ['is-top', 'is-bot'].forEach(function (where) {
      var bar = document.createElement('span');
      bar.className = 'mp-qd-mark ' + where;
      bar.style.left = 'calc(' + (p * 100).toFixed(3) + '% - 1px)';
      parts.marks.appendChild(bar);
    });
  }

  /* ---- render ---------------------------------------------------------- */

  var lastKey = '';

  function render() {
    if (!mount()) return;

    var qty = currentQuantity();
    var variant = currentVariantId();

    /* A change in the picker or the variant means the shopper is lining up
       something new, so it counts on top of the basket again.

       Measured on the storefront: this theme leaves the picker alone after an
       add, so every change here really is the shopper. A theme that reset the
       picker to 1 instead would need that reset ignored, or the strip would
       count the reset value on top of the pieces it just added. */
    if (qty !== lastQty || variant !== lastVariant) {
      countPicker = true;
      lastQty = qty;
      lastVariant = variant;
    }

    var unit = currentVariantPrice();
    var adding = countPicker ? qty : 0;
    var pieces = cart.count + adding;
    var cents = cart.cents + (unit * adding);
    var rate = bestOffer(pieces);

    var key = pieces + ':' + cents + ':' + rate;
    if (key === lastKey) return;
    var first = lastKey === '';
    lastKey = key;

    var copy = copyFor(pieces, cents);
    el.className = 'mp-qty-discount' + (rate > 0 ? ' mp-qty-discount--on' : '');

    swap(parts.inkMain, copy.main, true);
    swap(parts.liqMain, copy.main, true);
    swap(parts.inkSub, copy.sub, false);
    swap(parts.liqSub, copy.sub, false);

    measure();
    drawMarks();

    var p = progressFor(pieces);
    if (first || QUIET.matches) { nose.jump(p); paint(); }
    else { nose.to(p); run(); }

    if (!first && lastRate !== null && rate > lastRate) celebrate();
    lastRate = rate;
  }

  function start() {
    watchCartWrites();
    render();
    loadCart();

    /* Coming back from the cart page, another tab, or the back button. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) loadCart();
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) loadCart();
    });

    /* The plus and minus buttons set input.value directly, which fires no
       event, so listening alone is not enough. Events keep it instant where
       they do fire; the interval is the guarantee. render() returns early
       unless something actually changed, so the poll is close to free. */
    ['input', 'change', 'click'].forEach(function (type) {
      document.addEventListener(type, function () {
        window.requestAnimationFrame(render);
      }, true);
    });
    setInterval(render, 400);

    /* Belt and braces behind the fetch watcher: a plain form post, and the
       various names themes give their own cart events. */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && f.action.indexOf('/cart/add') !== -1) cartWritten();
    }, true);
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update', 'CartUpdateEvent']
      .forEach(function (type) {
        document.addEventListener(type, cartWritten);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
